var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMccCarRental(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Car_rent",
    "data-name": "Car rent",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8397",
    "data-name": "Rectangle 8397",
    width: 28,
    height: 28,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35256",
    "data-name": "Group 35256",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35899",
    "data-name": "Path 35899",
    d: "M23.876,11.013,22.254,6.49a4.338,4.338,0,0,0-4.1-2.9h-8.1a4.423,4.423,0,0,0-4.1,2.9L4.331,11.013a2.9,2.9,0,0,0-1.792,2.646v8.62a2.153,2.153,0,0,0,2.134,2.048,2.1,2.1,0,0,0,2.134-2.048V20.145H21.144v2.134a2.134,2.134,0,0,0,4.267,0v-8.62a2.37,2.37,0,0,0-1.536-2.646M8.684,7.6a1.384,1.384,0,0,1,1.365-.939h8.108a1.5,1.5,0,0,1,1.366.939l1.195,3.328H7.574ZM6.977,16.646a1.451,1.451,0,1,1-.108-2.9q.054,0,.108,0a1.451,1.451,0,0,1,.108,2.9H6.977m14.338,0a1.451,1.451,0,1,1,1.451-1.451,1.5,1.5,0,0,1-1.451,1.451",
    fill: "#b3b5c4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccCarRental);
export default __webpack_public_path__ + "static/media/mcc_carRental.a5a569d08c3c74b172e223467c97e2b1.svg";
export { ForwardRef as ReactComponent };